import React from "react";
import {
  FaYoutube,
  FaDiscord,
  FaFacebook,
  FaStore,
  FaDollarSign,
  FaTwitch,
  FaTiktok,
  FaKickstarterK,
} from "react-icons/fa";

import { FiChevronRight } from "react-icons/fi";

import {
  Container,
  ContentLogo,
  ImageLogo,
  Button,
  Title,
  Line,
  SocialButtons,
  SocialButton,
  Email,
} from "./home.styles";

import instagram from "../../assets/Instagram.svg";
import { analysticsEvent } from "../../services/index";

const Home = () => {
  return (
    <Container>
      <ContentLogo>
        <ImageLogo />
      </ContentLogo>

      <Title>LIPINHO</Title>

      <Button
        href="https://www.instagram.com/_LipinhO"
        onClick={() => analysticsEvent("ON_CLICK_INSTAGRAM")}
      >
        <img src={instagram} alt="instagram" />
        <p>
          Instagram<span>Me siga ♥</span>
        </p>
        <FiChevronRight color="#9c9c9c" size={18} />
      </Button>

      <Button
        href="https://www.tiktok.com/@lipinhor_"
        onClick={() => analysticsEvent("ON_CLICK_TIKTOK")}
      >
        <FaTiktok size={30} color="#018CF6" />
        <p>
          Tiktok<span>Vídeos novos todos os dias.</span>
        </p>

        <FiChevronRight color="#9c9c9c" size={18} />
      </Button>

      <Button
        href="https://www.twitch.tv/lipinho"
        onClick={() => analysticsEvent("ON_CLICK_TWITCH")}
      >
        <FaTwitch size={30} color="#018CF6" />
        <p>
          Twitch<span>Live todos os dias.</span>
        </p>
        <FiChevronRight color="#9c9c9c" size={18} />
      </Button>

      <Button
        href="https://kick.com/lipinho"
        onClick={() => analysticsEvent("ON_CLICK_KICK")}
      >
        <FaKickstarterK size={25} color="#018CF6" />
        <p>
          Kick<span>Live sem anúncios!</span>
        </p>

        <FiChevronRight color="#9c9c9c" size={18} />
      </Button>

      <Button
        href="https://www.youtube.com/@lipinho"
        onClick={() => analysticsEvent("ON_CLICK_YOUTUBE")}
      >
        <FaYoutube size={30} color="#018CF6" />
        <p>
          YouTube<span>Inscreva-se.</span>
        </p>
        <FiChevronRight color="#9c9c9c" size={18} />
      </Button>

      <Line />

      <SocialButtons>
        <SocialButton
          href="https://www.facebook.com/LipinhOr"
          onClick={() => analysticsEvent("ON_CLICK_FACEBOOK")}
        >
          <FaFacebook size={25} color="#018CF6" />
        </SocialButton>
        <SocialButton
          href="https://discord.gg/EZEeYwCqRs"
          onClick={() => analysticsEvent("ON_CLICK_DISCORD")}
        >
          <FaDiscord size={25} color="#018CF6" />
        </SocialButton>
        <SocialButton
          href="https://www.streamar.com.br/LipinhO"
          onClick={() => analysticsEvent("ON_CLICK_DONATE")}
        >
          <FaDollarSign size={25} color="#018CF6" />
        </SocialButton>
        <SocialButton href="https://streamelements.com/lipinho-95518/store">
          <FaStore
            size={25}
            color="#018CF6"
            onClick={() => analysticsEvent("ON_CLICK_STORE")}
          />
        </SocialButton>
      </SocialButtons>

      <Email>contato@lipinho.com</Email>
    </Container>
  );
};

export default Home;
